import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={25.701}
    height={25.387}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 63171 62399"
    {...props}
  >
    <path
      d="m1992 46222 14673-30815h29842l14674 30815H1992zm29594 14637c-7388 0-13444-5807-13846-13097h27692c-402 7290-6459 13097-13846 13097zm16103-46553c-128-268-398-439-696-439H32356V770c0-424-344-770-770-770-425 0-770 346-770 770v13097H16179c-297 0-568 171-696 439L75 46662c-113 237-96 518 45 743 141 223 387 357 651 357h15427c402 8140 7150 14637 15388 14637 8237 0 14986-6497 15388-14637h15426c265 0 510-134 653-357 141-225 157-506 43-743L47689 14306z"
      style={{
        fill: "#1c1c1d",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
